import React from 'react'
import './contact.css'
import ContactBanner from '../../Components/Contact/ContactBanner'
import ExperienceCards from '../../Components/Contact/ExperienceCards'
import GetInTouch from '../../Components/Contact/GetInTouch'
import HomeServices from '../../Components/Home/HomeServices'

const ContactPage = () => {
  return (
    <div>
      <ContactBanner/>
      <ExperienceCards/>
      <GetInTouch/>
      <HomeServices/>
    </div>
  )
}

export default ContactPage
